
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Coproratecabandbusserviceinahemadnagar() {



    const cardData =
    {
        keyword: ' Corporate Cab and Bus Service in Ahmednagar',
        heading: 'etravo :  Corporate Cab and Bus Service in Ahmednagar',
        headingDescription: 'eTravo offers dependable Corporate Cab and Bus Services in Ahmednagar, designed to meet the professional travel needs of modern businesses. From executive cabs for client visits and airport transfers to spacious buses for employee transportation, our services ensure comfort, punctuality, and safety. Whether you are organizing a corporate event, daily staff commute, or intercity travel, our fleet is equipped with modern amenities and managed by trained chauffeurs. Choose eTravo for streamlined and efficient corporate travel solutions in and around Ahmednagar.',

        top: 'Top Places to Visit in Ahmednagar with etravo',

        "topPlaces": [
    {
      "title": "Ahmednagar Fort",
      "description": "Built in 1427 by Malik Ahmad Nizam Shah I, Ahmednagar Fort is a significant historical structure that has witnessed numerous battles and political events. It served as a prison during British rule, housing leaders like Jawaharlal Nehru. The fort's robust architecture and historical relevance make it a must-visit site."
    },
    {
      "title": "Tomb of Salabat Khan II",
      "description": "Perched atop a hill, this three-story octagonal tomb offers panoramic views of Ahmednagar. Often mistaken as Chand Bibi's Mahal, it is the resting place of Salabat Khan II, a minister in the Nizam Shahi dynasty. The structure's unique architecture and scenic location attract many visitors."
    },
    {
      "title": "Cavalry Tank Museum",
      "description": "Established in 1994, the Cavalry Tank Museum is Asia's only museum dedicated to armored fighting vehicles. It houses over 50 exhibits, including vintage tanks from World Wars and the Indo-Pak wars, offering a unique glimpse into military history."
    },
    {
      "title": "Meherabad",
      "description": "Founded by spiritual leader Meher Baba in 1923, Meherabad serves as a pilgrimage site for his followers. The ashram complex includes his samadhi (tomb), a museum, and accommodations for visitors, providing a serene environment for reflection and spiritual activities."
    },
    {
      "title": "Rehekuri Blackbuck Sanctuary",
      "description": "Spread over 2.17 square kilometers, this sanctuary is home to the endangered Indian Blackbuck. It's a haven for wildlife enthusiasts and bird watchers, offering opportunities to observe various species in their natural habitat."
    },
    {
      "title": "Farah Bagh",
      "description": "Constructed in 1583 by the Nizam Shahi rulers, Farah Bagh was once a royal retreat. Though now in ruins, the octagonal palace and its surrounding gardens reflect the grandeur of Indo-Islamic architecture and offer insights into the region's royal past."
    },
    {
      "title": "Vishal Ganpati Temple",
      "description": "This temple is renowned for its massive 3.6-meter-tall idol of Lord Ganesha. Inspired by the Birla Mandir in Jaipur, the temple's architecture and spiritual ambiance make it a significant religious site in Ahmednagar."
    },
    {
      "title": "Kapurbawdi Lake",
      "description": "A tranquil spot ideal for picnics and relaxation, Kapurbawdi Lake is surrounded by lush greenery. It's also a popular location for bird watching, attracting various species throughout the year."
    },
    {
      "title": "Randha Falls",
      "description": "Located near Bhandardara, Randha Falls is a stunning waterfall where the Pravara River plunges from a height of 170 feet. The monsoon season enhances its beauty, making it a picturesque destination for nature lovers."
    },
    {
      "title": "Damdi Masjid",
      "description": "An architectural marvel, Damdi Masjid is known for its intricate carvings and historical significance. Built during the Nizam Shahi era, it stands as a testament to the region's rich cultural and religious heritage."
    }
  ],

         "services": [
    {
      "name": "Corporate Employee Transport in Ahmednagar",
      "description": "eTravo offers dependable and structured corporate employee transport services in Ahmednagar. Our solutions are ideal for organizations looking to streamline staff mobility through scheduled, door-to-door services. We prioritize safety, punctuality, and comfort by offering GPS-enabled vehicles, experienced drivers, and customized routing plans to meet your company's logistical needs efficiently."
    },
    {
      "name": "Cab & Bus Hire for Corporate Use in Ahmednagar",
      "description": "Whether your business needs cabs for executives or buses for large teams, eTravo provides reliable and flexible cab and bus hire options for corporate use in Ahmednagar. We offer hourly, daily, and monthly rental packages tailored to suit business meetings, offsite events, staff transport, or client pickups. Our fleet includes hatchbacks, sedans, SUVs, and buses equipped with all modern amenities."
    },
    {
      "name": "Affordable Office Commute Solutions in Ahmednagar",
      "description": "Cut down commuting hassles with eTravo's affordable office commute solutions in Ahmednagar. Our cost-effective plans are designed to suit businesses of all sizes, helping you provide your employees with consistent and stress-free daily transportation. We ensure optimal route planning, fuel efficiency, and transparent pricing to help reduce your operational overhead."
    },
    {
      "name": "Corporate Bus Rental in Ahmednagar",
      "description": "eTravo provides high-quality corporate bus rental services in Ahmednagar, perfect for companies needing transportation for their workforce or event attendees. Our buses are well-maintained, air-conditioned, and operated by trained drivers. Whether for a one-time corporate outing or a recurring commute service, we ensure professional coordination, safety, and comfort."
    },
    {
      "name": "Daily Staff Pickup and Drop Services Ahmednagar",
      "description": "Managing daily employee transportation has never been easier with eTravo’s staff pickup and drop services in Ahmednagar. We offer timely, route-optimized pickup and drop solutions for employees, ensuring seamless coverage across office hours, shifts, and business zones. Real-time vehicle tracking and dedicated customer support ensure complete peace of mind."
    },
    {
      "name": "AC Corporate Cabs and Buses in Ahmednagar",
      "description": "Ensure your staff travels in comfort with eTravo's fleet of air-conditioned corporate cabs and buses in Ahmednagar. Our climate-controlled vehicles are ideal for both short commutes and long-distance corporate travel, offering plush interiors, reliable air conditioning, and courteous chauffeurs for a top-tier transport experience."
    },
    {
      "name": "Business Travel Solutions Ahmednagar",
      "description": "eTravo offers complete business travel solutions in Ahmednagar for companies needing transport flexibility and convenience. From airport transfers and intercity travel to daily shuttles and event-specific rentals, our comprehensive packages are ideal for executives, employees, and clients alike. We manage everything from scheduling to tracking so your team can focus on work, not logistics."
    },
    {
      "name": "Reliable Corporate Cab & Bus Services in Ahmednagar",
      "description": "When it comes to reliability and consistency, eTravo leads in offering corporate cab and bus services in Ahmednagar. Our transport solutions are trusted by businesses for their efficiency, fleet quality, driver professionalism, and customer service. Whether it’s for a small team or a large organization, we deliver hassle-free and dependable commuting options tailored to your business."
    }
  ],
  "tableData": [
    ["Corporate Employee Transport in Ahmednagar", "Cab & Bus Hire for Corporate Use in Ahmednagar"],
    ["Affordable Office Commute Solutions in Ahmednagar", "Corporate Bus Rental in Ahmednagar"],
    ["Daily Staff Pickup and Drop Services Ahmednagar", "AC Corporate Cabs and Buses in Ahmednagar"],
    ["Business Travel Solutions Ahmednagar", "Reliable Corporate Cab & Bus Services in Ahmednagar"]
  ],







     "whychoose": [
    {
        "WhyChooseheading": "Timely and Dependable Transportation",
        "WhyChoosedescription": "At eTravo, we pride ourselves on punctuality. Our corporate cab and bus services in Ahmednagar ensure timely pickups and drop-offs, helping your team stay productive and stress-free."
    },
    {
        "WhyChooseheading": "Diverse Fleet for All Corporate Needs",
        "WhyChoosedescription": "From executive cabs to spacious corporate buses, eTravo offers a versatile fleet to suit your transportation requirements in Ahmednagar. All vehicles are air-conditioned and designed for maximum comfort."
    },
    {
        "WhyChooseheading": "Skilled and Courteous Drivers",
        "WhyChoosedescription": "Our professional drivers are trained in corporate service standards. They are well-versed with routes in and around Ahmednagar, ensuring smooth, safe, and professional journeys for your staff and guests."
    },
    {
        "WhyChooseheading": "Transparent and Budget-Friendly Pricing",
        "WhyChoosedescription": "eTravo provides honest, upfront pricing for all our corporate cab and bus services in Ahmednagar. No hidden charges—just clear, cost-effective solutions for your business travel needs."
    },
    {
        "WhyChooseheading": "Focus on Safety and Security",
        "WhyChoosedescription": "Safety comes first at eTravo. Our vehicles feature GPS tracking, seat belts, and emergency safety kits to ensure that every ride is secure and reliable for your team."
    },
    {
        "WhyChooseheading": "Round-the-Clock Service Availability",
        "WhyChoosedescription": "Whether you need early morning pickups or late-night drops, eTravo is available 24/7 in Ahmednagar to match your business schedule. Our support team is always ready to assist."
    },
    {
        "WhyChooseheading": "Streamlined Booking Experience",
        "WhyChoosedescription": "Booking corporate cabs and buses with eTravo is quick and easy through our website or customer service team. Manage your reservations with real-time updates and full flexibility."
    },
    {
        "WhyChooseheading": "Custom Corporate Travel Packages",
        "WhyChoosedescription": "We offer tailored transport plans for businesses of all sizes. Whether it's daily employee travel, corporate events, or intercity meetings, eTravo adapts to your needs in Ahmednagar."
    }
]



















    }


    // Corporate Bus Services Pune – eTravo

// Corporate Cab and Bus Service in Ahmednagar – eTravo

const faqData = [
    [
        {
            question: 'What corporate cab and bus services does eTravo provide in Ahmednagar?',
            answer: 'eTravo offers a full range of corporate transportation services in Ahmednagar, including daily employee cab pickups, staff shuttle buses, corporate event travel, and VIP executive transfers.',
        },
        {
            question: 'Can eTravo support regular employee commutes for our office in Ahmednagar?',
            answer: 'Yes, eTravo specializes in reliable, scheduled transportation solutions for employees. We offer both cab and bus options tailored to your company’s shift timings and routes.',
        },
        {
            question: 'Are vehicles available for both small and large corporate teams?',
            answer: 'Absolutely. For small groups, we offer well-maintained corporate cabs, and for larger teams, we provide AC buses and coaches with flexible seating capacities.',
        },
        {
            question: 'Does eTravo offer real-time tracking and monitoring for corporate trips?',
            answer: 'Yes, all eTravo vehicles are GPS-enabled, and we provide real-time tracking dashboards and automated reporting to ensure safety and transparency for corporate travel managers.',
        },
        {
            question: 'Can we book one-time corporate transport for events or client visits in Ahmednagar?',
            answer: 'Definitely. eTravo provides on-demand cab and bus bookings for corporate events, conferences, and VIP client visits, ensuring professional service and timely travel.',
        },
        {
            question: 'Is dedicated support available for managing our Ahmednagar transport account?',
            answer: 'Yes, every corporate client receives a dedicated relationship manager for seamless coordination, regular reporting, and quick support for any changes or issues.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Sandeep Joshi',
        designation: 'Operations Manager, NexaTech Ltd.',
        rating: [1, 1, 1, 1, 1],
        text: '“We’ve been using eTravo for corporate cab and bus services in Ahmednagar for over a year. Their punctuality, vehicle quality, and support team have been excellent. Highly professional.”',
    },
    {
        name: 'Ms. Ritu More',
        designation: 'Facility Coordinator, InvoCore Pvt. Ltd.',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo made it easy to manage daily employee transport in Ahmednagar. From route planning to real-time tracking, everything is smooth. A dependable corporate mobility partner.”',
    },
];





















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab and Bus Service in Ahmednagar",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-bus-service-ahmednagar.jpg",
  "description": "Book professional and affordable Corporate Cab and Bus Services in Ahmednagar with eTravo. We offer employee transport solutions, staff pick and drop services, and executive cab & bus rentals for corporate use. Clean vehicles, punctual drivers, and flexible plans for daily or event-based travel.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "4178"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2299",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-and-bus-service-in-ahmednagar"
  }
};







    return (
        <div>
<Helmet>
  <title>Corporate Cab and Bus Service in Ahmednagar | Staff Transport & Rentals | eTravo</title>
  <meta 
    name="description" 
    content="Hire reliable corporate cab and bus service in Ahmednagar with eTravo. Ideal for staff transportation, business travel, and daily office commute with AC cabs and buses." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/2.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Coproratecabandbusserviceinahemadnagar;